import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/bg_less_logo.png'


const _withScopeId = n => (_pushScopeId("data-v-0b12a041"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hero-section" }
const _hoisted_2 = { class: "info-layer" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-continer" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Logo",
    class: "logo"
  })
], -1))
const _hoisted_4 = {
  key: 0,
  class: "info-container"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "Who am I?", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "description" }, " Electronics engineer focused in software development with knowledge about multiple technologies that will build what your business needs. ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "projects-link-btn",
  href: "#projects-section"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Projects")
], -1))
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]

import { ref } from 'vue';

//* Variables.

export default /*#__PURE__*/_defineComponent({
  __name: 'HeroSection',
  setup(__props) {

const showInfo = ref<boolean>(false);

setTimeout(() => {
  showInfo.value = true;
}, 180);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_Transition, { name: "info" }, {
        default: _withCtx(() => [
          (showInfo.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_8))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})